import React from 'react';
import BaseRowView from '../..';
import "./styles.css";
import { ImageAsset } from "res";

/**
 * @function TransactionView
 * @param {STRING} billerName - The Biller Name of the transaction is passed through to the mainText of the BaseRowView.
 * @param {STRING} date - The date of the transaction is passed through to the subText of the BaseRowView.
 * @param {STRING} amount - The amount of the transaction is passed as a child to the BaseRowView.
 * @param {STRING} leftIcon - The ImageAsset of the biller icon is passed to the BaseRowView as the leftIcon.
 * @param {STRING} positiveClassName - this is a class that makes the amount green when the amount is positive.
 * @param {STRING} className - Additional classes to add to the TransactionView.
 * @return {React.Component}
 * @exported true
 * @description This is a row used to show transactions. It is built off of the BaseRowView.
 * @example
 * <TransactionView className="addedClass" leftIcon="PizzaTown" billerName="Netflix" date="Sep 05, 2022" amount="+$12.99" />
 */
export default function TransactionView(props) {
  const transaction = props.transaction ?? {};
  const billerName = props.billerName ?? "[Biller Name]";
  const date = props.date ?? "[date]";
  const amount = props.amount ?? "[AMT]";
  const leftIcon = props.leftIcon ?? "";
  const className = props.className ?? "";
  const positiveClassName = props.positiveClassName ?? "";
  const dataPoint = props.dataPoint ?? "";
  const id = props.id ?? "0";
  let disputeStatus = props.disputeStatus ?? "";
  const baseRowViewDataPoint = props.dataPoint ? { dataPoint: props.dataPoint + "_Name_Label" } : {};

  if(transaction.transactionDispute) {
    disputeStatus = transaction.transactionDispute.type.description;
  }

  const icon = typeof leftIcon === "string"
    ? <ImageAsset id={ leftIcon } className="left-icon" />
    : leftIcon;
  
  return (
    <div className={className + " transaction-view"} data-point={ dataPoint }>
      <BaseRowView { ...baseRowViewDataPoint } leftIcon={ icon } mainText={ billerName } subText={ date } onClick={props.onClick} id={ id }>
        <div className={ positiveClassName + " text-right"}>{ amount }</div>
        { transaction.transactionDispute &&
        <p className="text-right sub-text">{ disputeStatus }</p>
        }
      </BaseRowView>
    </div>
  );
}